var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F7DF1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5775 17.5775H46.4225V46.4225H17.5775V17.5775Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1619 41.6825L27.3693 40.3466C27.7952 41.1017 28.1826 41.7405 29.1118 41.7405C30.0025 41.7405 30.5641 41.3921 30.5641 40.0368V30.8201H33.2748V40.0751C33.2748 42.8827 31.6291 44.1607 29.228 44.1607C27.0595 44.1607 25.8008 43.0376 25.1618 41.6823",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7471 41.392L36.9543 40.1141C37.5353 41.063 38.2905 41.76 39.6264 41.76C40.7496 41.76 41.4658 41.1984 41.4658 40.4239C41.4658 39.4945 40.7301 39.1653 39.4908 38.6233L38.8133 38.3327C36.8576 37.5003 35.5603 36.4547 35.5603 34.2473C35.5603 32.2142 37.1092 30.6652 39.5297 30.6652C41.2529 30.6652 42.4921 31.2655 43.3827 32.8339L41.2722 34.1892C40.8075 33.3566 40.3042 33.0275 39.5297 33.0275C38.7358 33.0275 38.2324 33.5309 38.2324 34.1892C38.2324 35.0024 38.7358 35.3317 39.8975 35.8351L40.5751 36.1255C42.8793 37.1131 44.1766 38.1198 44.1766 40.3852C44.1766 42.825 42.2597 44.1609 39.6846 44.1609C37.1674 44.1609 35.5409 42.9605 34.7472 41.392",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8451,
    height: 28.8451,
    fill: "white",
    transform: "translate(17.5775 17.5775)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/Javascript.11e4aa556c853272bc901409d6bfb1cd.svg";
export { ForwardRef as ReactComponent };